import {ReactNode} from "react";
import {css} from "@panda/css";

import {BrandBuildingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../../atoms/OfferBoxBase";

interface IProps {
    children: ReactNode;
    href: string;
    onClick: () => void;
}

export const NearbyOffersMoreCard = (props: IProps) => {
    const {children, onClick, href} = props;

    return (
        <a href={href} target="_blank" onClick={onClick} className={link}>
            <OfferBoxBase className={content}>
                <BrandBuildingIcon size="10" wrapperSize="11.2" wrapperColor="var(--colors-primary)" wrapperType="circle" className={iconStyles} />

                <Text align="center" variant="headline_3" className={textStyle}>
                    {children}
                </Text>
            </OfferBoxBase>
        </a>
    );
};

const link = css({
    width: "100%",
    maxWidth: "375px"
});

const content = css({
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "4rem 0"
});

const iconStyles = css({
    mb: "3.6rem"
});

const textStyle = css({
    padding: "0 3.5rem",
    color: "var(--colors-secondary)",

    "&:hover, &:focus": {
        color: "var(--colors-secondary)"
    }
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {BrandBuildingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../../atoms/OfferBoxBase";

interface IProps {
    children: ReactNode;
    href: string;
    onClick: () => void;
}

export const NearbyOffersMoreCard = (props: IProps) => {
    const {children, onClick, href} = props;

    return (
        <a href={href} target="_blank" onClick={onClick} className={link}>
            <OfferBoxBase className={content}>
                <BrandBuildingIcon size="10" wrapperSize="11.2" wrapperColor="var(--colors-primary)" wrapperType="circle" className={iconStyles} />

                <Text align="center" variant="headline_3" className={textStyle}>
                    {children}
                </Text>
            </OfferBoxBase>
        </a>
    );
};

const link = css({
    width: "100%",
    maxWidth: "375px"
});

const content = css({
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "4rem 0"
});

const iconStyles = css({
    mb: "3.6rem"
});

const textStyle = css({
    padding: "0 3.5rem",
    color: "var(--colors-secondary)",

    "&:hover, &:focus": {
        color: "var(--colors-secondary)"
    }
});
